import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		navTree: [], // 导航菜单树
		allRouter: [
			{
				id: 1,
				showName: '佰付美营销平台',
				url: '/'
			},
			// {
			//   id: 2,
			//   showName: "公告通知",
			//   children: [
			//     { id: 21, showName: "最新公告", url: "/noticeList" },
			//   ]
			// },
			{
				id: 3,
				showName: '营销场景对接',
				children: [
					{
						id: 31,
						showName: '去加油',
						url: '/sceneFuel',
						noicon: 'static/img/headerIcon/sceneIcon/oilnomal.png',
						icon: 'static/img/headerIcon/sceneIcon/oil.png'
					},
					{
						id: 32,
						showName: '油卡充值',
						url: '/sceneOilPay',
						noicon: 'static/img/headerIcon/sceneIcon/oilcardnomal.png',
						icon: 'static/img/headerIcon/sceneIcon/oilcard.png'
					},
					{
						id: 33,
						showName: '生活服务',
						url: '/sceneLifeSer',
						noicon: 'static/img/headerIcon/sceneIcon/servenomal.png',
						icon: 'static/img/headerIcon/sceneIcon/serve.png'
					},
					{
						id: 34,
						showName: '数字娱乐',
						url: '/sceneDigital',
						noicon: 'static/img/headerIcon/sceneIcon/gamenomal.png',
						icon: 'static/img/headerIcon/sceneIcon/game.png'
					},
					{
						id: 35,
						showName: '油证通',
						url: '/sceneOilCard',
						noicon: 'static/img/headerIcon/sceneIcon/oilpapersn.png',
						icon: 'static/img/headerIcon/sceneIcon/oilpapers.png'
					}
				]
			},
			{
				id: 4,
				showName: '营销活动类别',
				children: [
					{
						id: 41,
						showName: '立减',
						url: '/actStandBy',
						noicon: 'static/img/headerIcon/activeicon/offnomal.png',
						icon: 'static/img/headerIcon/activeicon/off.png'
					},
					{
						id: 42,
						showName: '购券',
						url: '/actBuyCoupon',
						noicon: 'static/img/headerIcon/activeicon/buycounomal.png',
						icon: 'static/img/headerIcon/activeicon/buycou.png'
					},
					{
						id: 43,
						showName: '券码兑换',
						url: '/actExchange',
						noicon: 'static/img/headerIcon/activeicon/exchnomal.png',
						icon: 'static/img/headerIcon/activeicon/exch.png'
					},
					{
						id: 44,
						showName: '渠道发券',
						url: '/actChannelSend',
						noicon: 'static/img/headerIcon/activeicon/ditchnomal.png',
						icon: 'static/img/headerIcon/activeicon/ditch.png'
					},
					{
						id: 45,
						showName: '后台发券',
						url: '/actAdminSend',
						noicon: 'static/img/headerIcon/activeicon/adminnomal.png',
						icon: 'static/img/headerIcon/activeicon/admin.png'
					},
					{
						id: 46,
						showName: '领券',
						url: '/actGetCoupon',
						noicon: 'static/img/headerIcon/activeicon/getcounomal.png',
						icon: 'static/img/headerIcon/activeicon/getcou.png'
					},
					{
						id: 47,
						showName: '抽奖',
						url: '/actLottery',
						noicon: 'static/img/headerIcon/activeicon/drawnomal.png',
						icon: 'static/img/headerIcon/activeicon/draw.png'
					},
					{
						id: 48,
						showName: '分享裂变',
						url: '/actShare',
						noicon: 'static/img/headerIcon/activeicon/sharenomal.png',
						icon: 'static/img/headerIcon/activeicon/share.png'
					}
				]
			},
			{
				id: 5,
				showName: '对接文档说明',
				children: [
					{
						id: 51,
						showName: 'H5支付对接',
						url: '/dockH5pay',
						noicon: 'static/img/headerIcon/payIcon/H5nomal.png',
						icon: 'static/img/headerIcon/payIcon/H5.png'
					},
					{
						id: 52,
						showName: 'SDK支付对接',
						url: '/dockSdkpay',
						noicon: 'static/img/headerIcon/payIcon/SDKnomal.png',
						icon: 'static/img/headerIcon/payIcon/sdk.png'
					},
					{
						id: 53,
						showName: '维纳宝营销发券对接',
						url: '/dockWnbsendC',
						noicon: 'static/img/headerIcon/payIcon/wnbcounomal.png',
						icon: 'static/img/headerIcon/payIcon/wnbcou.png'
					},
					{
						id: 54,
						showName: '智慧加油API对接',
						url: '/dockFuelAPI',
						noicon: 'static/img/headerIcon/payIcon/APInomal.png',
						icon: 'static/img/headerIcon/payIcon/API.png'
					}
				]
			},
			{ id: 6, showName: '商务合作', url: '/cooperate' }
		],
		fIndex: sessionStorage.getItem('fIndexLocal') ? sessionStorage.getItem('fIndexLocal') : 0,
		CIndex: sessionStorage.getItem('CIndexLocal') ? sessionStorage.getItem('CIndexLocal') : 0
	},
	getters: {},
	mutations: {
		updateSelect(state, data) {
			if (data) {
				state.fIndex = data.fIndex;
				state.CIndex = data.cIndex;
				sessionStorage.setItem('fIndexLocal', data.fIndex);
				sessionStorage.setItem('CIndexLocal', data.cIndex);
			} else {
				state.fIndex = 0;
				state.CIndex = 0;
				if (sessionStorage.getItem('fIndexLocal')) {
					sessionStorage.removeItem('fIndexLocal');
				}
				if (sessionStorage.getItem('CIndexLocal')) {
					sessionStorage.removeItem('CIndexLocal');
				}
			}
		}
	},
	actions: {},
	modules: {}
});

export default store;



// WEBPACK FOOTER //
// ./src/Store/index.js